import { Role } from './role';

export class User {
  id: number;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  first_name?: string;
  last_name?: string;
  avatar: string;
  role: Role;
  token?: string;
}
